import script from "./MessagingStatsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagingStatsModal.vue?vue&type=script&setup=true&lang=js"

import "./MessagingStatsModal.vue?vue&type=style&index=0&id=1f433d19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f433d19"]])

export default __exports__